import { render, staticRenderFns } from "./OrganizationUpdate.vue?vue&type=template&id=4fb627b1&scoped=true"
import script from "./OrganizationUpdate.vue?vue&type=script&lang=js"
export * from "./OrganizationUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb627b1",
  null
  
)

export default component.exports